import { ApplicationsList } from './ApplicationsList';
import { useApplicationsList } from './useApplicationsList';
import { useCallback, useState } from 'react';
import {
	ApplicationSummary,
	UserRole,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { useApplicationId } from '../../../hooks/useApplicationId';
import { DASHBOARD_PATH, INTERVIEW_LANDING } from '../../../shared/Routes';
import { Filter } from './Filter';
import { Button, Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { useBatchId } from '../../../hooks/useBatchId';
import { useRedirectToLogin } from '../../../hooks/useRedirectToLogin';
import { VerifyResultsModal } from './VerifyResultsModal';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const ApplicationsListContainer = () => {
	const { applicationsList, onPageChange, filter, onFilterChange, paging } =
		useApplicationsList();
	const [openResultsModal, setOpenResultsModal] = useState(false);
	const [applicationToVerify, setApplicationToVerify] =
		useState<ApplicationSummary>();
	const { navigateWithApplicationId } = useApplicationId();
	const { navigateWithBatchId } = useBatchId();
	const { t } = useTranslation();
	const { role } = useRedirectToLogin();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;

	const showDashboardButton =
		role === UserRole.APPROVER ||
		role === UserRole.ADMIN ||
		role === UserRole.ZC;

	const handleEvaluateClick = useCallback(
		(application: ApplicationSummary) => {
			navigateWithApplicationId(INTERVIEW_LANDING, application.applicationId);
		},
		[navigateWithApplicationId]
	);

	const handleVerifyResultsClick = useCallback(
		(application: ApplicationSummary) => {
			setApplicationToVerify(application);
			setOpenResultsModal(true);
		},
		[]
	);

	const handleDashboardClick = useCallback(() => {
		navigateWithBatchId(DASHBOARD_PATH);
	}, [navigateWithBatchId]);

	return (
		<div className="flex flex-col p-[16px]">
			<div className="flex gap-8">
				<Text className="hidden md:block font-sans font-bold text-xl text-secondary-black mb-4">
					{t('listOfCandidates')}
				</Text>
				{showDashboardButton && (
					<Button
						type={isMobile ? 'default' : 'link'}
						onClick={handleDashboardClick}
						className={`text-center ${
							isMobile
								? 'w-full mb-4 text-primary-blue font-bold'
								: 'underline hover:underline-offset-4 text-primary-blue font-bold p-0'
						}`}
						block={isMobile}
					>
						{t('dashboard')}
					</Button>
				)}
			</div>
			<div className="mb-[16px]">
				{filter && <Filter value={filter} onFilterChange={onFilterChange} />}
			</div>
			<ApplicationsList
				data={applicationsList}
				onPageChange={onPageChange}
				onEvaluateClick={handleEvaluateClick}
				onVerifyResultsClick={handleVerifyResultsClick}
				pageConfig={paging}
			/>
			<VerifyResultsModal
				openModal={openResultsModal}
				onClose={() => setOpenResultsModal(false)}
				application={applicationToVerify}
			/>
		</div>
	);
};
